var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 12", fill: "none" }, props),
    React.createElement("path", { d: "M10.792 5.036l-.623.113c-2.44.444-4.94.444-7.379 0l-.623-.113v2.902c0 1.173.951 2.125 2.125 2.125h4.375a2.125 2.125 0 0 0 2.125-2.126v-2.9zM5.39 3.188c-.88 0-1.734.3-2.421.85l-.132.104.133.024c2.321.422 4.7.422 7.021 0l.131-.024-.13-.105a3.876 3.876 0 0 0-2.422-.85H5.39zm6.403 4.75c0 1.725-1.4 3.124-3.125 3.125H4.292a3.125 3.125 0 0 1-3.125-3.126v-3.25L.2 3.963a.5.5 0 0 1 .6-.8l.856.642.688-.55a4.875 4.875 0 0 1 3.045-1.067h.59V1h-.811a.5.5 0 0 1 0-1h2.625a.5.5 0 0 1 0 1H6.98v1.188h.59c1.106 0 2.18.376 3.045 1.068l.686.548.857-.642a.5.5 0 0 1 .6.8l-.966.725v3.25z", fill: "#9C9C9C" })
  );
});